export default {
  // Common
  "appName": "Qonso",
  "loading": "Carregando...",
  "error": "Ocorreu um erro",
  "success": "Sucesso",
  "save": "Salvar",
  "cancel": "Cancelar",
  "confirm": "Confirmar",
  "back": "Voltar",
  "backToHome": "Voltar para o início",
  "backToLogin": "Voltar para o login",
  "backToForgotPassword": "Voltar para esqueci a senha",
  "next": "Próximo",
  "submit": "Enviar",
  "delete": "Excluir",
  "edit": "Editar",
  "view": "Visualizar",
  "close": "Fechar",
  "and": "e",
  "pleaseWait": "Por favor, aguarde...",
  "verifyingLink": "Verificando seu link",
  
  // Auth
  "login": "Entrar",
  "register": "Registrar",
  "forgotPassword": "Esqueci a senha",
  "resetPassword": "Redefinir senha",
  "email": "Email",
  "password": "Senha",
  "confirmPassword": "Confirmar senha",
  "fullName": "Nome completo",
  "age": "Idade",
  "country": "País",
  "signIn": "Entrar",
  "signUp": "Registrar",
  "signOut": "Sair",
  "createAccount": "Criar conta",
  "creatingAccount": "Criando conta...",
  "signingIn": "Entrando...",
  "signInToTrack": "Entre para acompanhar sua hidratação",
  "joinQonsoToday": "Junte-se ao Qonso hoje e comece sua jornada de hidratação!",
  "alreadyHaveAccount": "Já tem uma conta?",
  "dontHaveAccount": "Não tem uma conta?",
  "rememberPassword": "Lembrou sua senha?",
  "forgotPasswordQuestion": "Esqueceu sua senha?",
  "resetPasswordInstructions": "Digite seu email e enviaremos um link para redefinir sua senha",
  "sendResetLink": "Enviar link",
  "sending": "Enviando...",
  "passwordResetSent": "Um link de redefinição foi enviado para seu email. Por favor, verifique sua caixa de entrada e siga as instruções.",
  "passwordUpdated": "Senha atualizada com sucesso",
  "passwordsDoNotMatch": "As senhas não coincidem",
  "passwordMinLength": "A senha deve ter pelo menos 6 caracteres",
  "emailRequired": "O email é obrigatório",
  "passwordRequired": "A senha é obrigatória",
  "fullNameRequired": "O nome completo é obrigatório",
  "ageRequired": "A idade é obrigatória",
  "countryRequired": "O país é obrigatório",
  "acceptTerms": "Aceito os",
  "termsRequired": "Você deve aceitar os termos para continuar",
  "emailConfirmationRequired": "Por favor, verifique seu email para confirmar sua conta",
  "emailConfirmationSent": "Um email de confirmação foi enviado para seu endereço. Por favor, verifique sua caixa de entrada e siga as instruções para completar seu registro.",
  "emailConfirmationSuccess": "Seu email foi confirmado com sucesso!",
  "emailConfirmationFailed": "A confirmação do email falhou",
  "emailConfirmed": "Email Confirmado",
  "emailVerifiedRedirect": "Seu email foi verificado. Você será redirecionado para o painel.",
  "confirmingEmail": "Confirmando seu email",
  "pleaseWaitVerifying": "Por favor, aguarde enquanto verificamos seu email...",
  "invalidConfirmationLink": "Link de confirmação inválido",
  "failedToConfirmEmail": "Falha ao confirmar email",
  "goToDashboard": "Ir para o Painel",
  "selectCountry": "Selecione um país",
  "selectCountries": "Selecionar países",
  "leaveEmptyForAllCountries": "Deixe vazio para disponibilizar em todos os países",
  "targetCountries": "Países alvo",
  "allCountries": "Todos os países",
  "pleaseAllFields": "Por favor preencha todos os campos",
  "loginFailed": "Email ou senha incorretos. Por favor, tente novamente.",
  "registrationFailed": "O registro falhou. Por favor, tente novamente.",
  "emailAlreadyRegistered": "Este email já está registrado",
  "invalidEmail": "Por favor, insira um email válido",
  "invalidAge": "Por favor, insira uma idade válida",
  "invalidPassword": "Formato de senha inválido",
  "currentPassword": "Senha atual",
  "newPassword": "Nova senha",
  "confirmNewPassword": "Confirmar nova senha",
  "updating": "Atualizando...",
  "emailCannotBeChanged": "O email não pode ser alterado",
  "tooManyAttempts": "Muitas tentativas. Por favor, tente novamente em alguns minutos.",
  "sessionExpired": "Sua sessão expirou. Por favor, faça login novamente.",
  "networkError": "Erro de rede. Por favor, verifique sua conexão e tente novamente.",
  "unknownError": "Ocorreu um erro inesperado. Por favor, tente novamente.",
  "checkYourEmail": "Verifique seu email",
  "didntReceiveEmail": "Não recebeu o email?",
  "resendEmail": "Reenviar email",
  "emailConfirmedInstructions": "Seu email foi confirmado com sucesso. Agora você pode fazer login em sua conta.",
  "proceedToLogin": "Continuar para o login",
  "passwordResetInstructions": "Enviar-lhe-emos uma ligação por correio eletrónico para redefinir a sua palavra-passe.",
  "resetLinkSent": "Um novo link de redefinição foi enviado",
  "resetLinkFailed": "Falha ao enviar link de redefinição",
  "emailVerificationInstructions": "Receberá uma link por correio eletrónico para confirmar a sua inscrição.",
  "setNewPassword": "Definir nova senha",
  "createNewPassword": "Crie uma nova senha para sua conta",
  "passwordResetComplete": "Sua senha foi redefinida. Agora você pode usar sua nova senha para acessar sua conta.",
  "passwordUpdateFailed": "Falha ao atualizar a senha. Por favor, tente novamente.",
  "invalidResetLink": "Link de redefinição inválido ou expirado",
  "errorResendingEmail": "Erro ao reenviar o email de verificação. Por favor, tente novamente mais tarde.",

  // Admin
  "adminLogin": "Login do Administrador",
  "adminLoginDescription": "Entre para acessar o painel do administrador",
  
  // Home
  "mainTitle": " Hidrate-se, Acumule, Ganhe! 💧",
  "mainTitleHighlight": "Com Qonso, ganhe prémios por beber água",
  "homeDescription": "A Qonso ajuda você a se manter hidratado enquanto recompensa seus bons hábitos. Beba água, ganhe pontos e troque por presentes.",
  "getStarted": "Começar",
  "features": "Recursos",
  "whyUseQonso": "Por que usar o Qonso?",
  "featuresDescription": "Descubra como o Qonso ajuda você a manter hábitos saudáveis de hidratação enquanto torna tudo divertido e gratificante.",
  "trackHydration": "Acompanhamento de hidratação",
  "trackHydrationDescription": "Registre seu consumo diário de água e monitore seu progresso com nosso sistema fácil de usar.",
  "dailyGoals": "Metas diárias",
  "dailyGoalsDescription": "Qonso incentiva você a atingir uma meta diária de 2,5 L de água.",
  "participateSurveys": "Participe de pesquisas",
  "participateSurveysDescription": "Ganhe mais pontos participando das nossas diferentes pesquisas.",
  "redeemRewards": "Resgate recompensas",
  "redeemRewardsDescription": "Converta seus pontos ganhos em recompensas e ofertas especiais.",
  
  // Benefits section
  "benefitsOfHydration": "Benefícios de manter-se hidratado",
  "benefitsDescription": "A hidratação adequada é essencial para sua saúde e bem-estar. Aqui está o motivo pelo qual você deve acompanhar sua ingestão de água com o Qonso.",
  "improvedEnergyLevels": "Melhores níveis de energia",
  "improvedEnergyDescription": "Manter-se hidratado ajuda a manter seus níveis de energia ao longo do dia, reduzindo a fadiga e melhorando o foco.",
  "betterPhysicalPerformance": "Melhor desempenho físico",
  "betterPhysicalDescription": "A hidratação adequada melhora o desempenho físico durante exercícios e atividades diárias.",
  "enhancedCognition": "Função cognitiva aprimorada",
  "enhancedCognitionDescription": "A água ajuda seu cérebro a funcionar de maneira ideal, melhorando a concentração e a memória.",
  "healthierSkin": "Pele mais saudável",
  "healthierSkinDescription": "Manter-se hidratado ajuda a manter a elasticidade da pele e promove uma aparência mais saudável e radiante.",
  "improvedDigestion": "Digestão melhorada",
  "improvedDigestionDescription": "A água é essencial para uma digestão adequada e ajuda a prevenir a constipação.",
  "joinCommunity": "Junte-se à nossa comunidade",
  "joinCommunityDescription": "Conecte-se com milhares de usuários que estão melhorando seus hábitos de hidratação com o Qonso.",
  
  // Testimonials
  "userTestimonials": "O que nossos usuários dizem",
  "testimonialsDescription": "Junte-se a milhares de usuários satisfeitos que melhoraram seus hábitos de hidratação com o Qonso.",
  "testimonial1": "O Qonso mudou completamente a forma como acompanho minha ingestão de água. O sistema de recompensas me mantém motivada!",
  "testimonialRole1": "Entusiasta de fitness",
  "testimonial2": "Eu nunca percebi o quão pouca água eu bebia até começar a usar o Qonso. Agora estou devidamente hidratado todos os dias.",
  "testimonialRole2": "Trabalhador de escritório",
  "testimonial3": "As pesquisas e recompensas tornam a hidratação divertida. Já resgatei várias recompensas!",
  "testimonialRole3": "Estudante",
  
  // CTA
  "ctaHeading": "Pronto para iniciar sua jornada de hidratação?",
  "ctaDescription": "Junte-se ao Qonso hoje e transforme seus hábitos de hidratação enquanto ganha recompensas emocionantes.",
  
  // Dashboard
  "welcomeBack": "Bom dia",
  "hydrationTracking": "Valide o seu consumo de água para ganhar pontos",
  "dailyGoal": "Meta diária",
  "streak": "Sequência",
  "points": "Pontos",
  "daysInARow": "Dias consecutivos",
  "totalEarned": "Total de pontos ganhos",
  "validateConsumption": "💧Registrar Seu Consumo De Água",
  "dailyLimitReached": "Limite diário atingido",
  "limitReached": "Limite diário atingido!",
  "streak": "Sequência",
  "days": "d",
  "points": "Pontos",
  "time": "Hora",
  "weeklyProgress": "7 Dias",
  "total": "Total",
  "goals": "Objetivos",
  "comeBackTomorrow": "Mandou Bem! Você Registrou O Consumo De Hoje. Te Vejo Amanhã? 😉",
  "waterType": "Tipo de água",
  "plainWater": "Água natural",
  "plainWaterDesc": "Água comum",
  "mineralWater": "Água mineral",
  "mineralWaterDesc": "Água mineral natural",
  "sparklingWater": "Água com gás",
  "sparklingWaterDesc": "Água carbonatada",
  "flavoredWater": "Água saborizada",
  "flavoredWaterDesc": "Água com sabores naturais",
  "uploadPhoto": "Tire uma fotografia do seu copo ou garrafa de água",
  "photoSelected": "Foto selecionada",
  "sunday": "Dom",
  "monday": "Seg",
  "tuesday": "Ter",
  "wednesday": "Qua",
  "thursday": "Qui",
  "friday": "Sex",
  "saturday": "Sáb",
  "photoRequired": "Por favor, tire uma foto da sua água",
  "fixedAmount": "Volume de água", 
  "dailyProgress": "Progresso",
  "consumptionValidated": "Consumo validado",
  "validate": "Confirmar",
  "validating": "Validação em curso",
  "totalWaterConsumed": "Água Total Consumida",
  "lifetimeConsumption": "Consumo total",
  "ofDailyGoals": "das metas diárias",
  "showWeeklyStats": "Mostrar estatísticas semanais",
  "hideWeeklyStats": "Ocultar estatísticas semanais",
  "weeklyProgress": "Progresso semanal",
  "lastWeek": "Semana passada",
  "today": "Hoje",
  "insights": "Informações",
  "lifetimeAchievement": "Você consumiu um total de",
  "ofWater": "de água desde que começou",
  "startTrackingToday": "Comece a registrar seu consumo de água hoje!",
  "keepUpStreak": "Continue sua sequência de {{streak}} dias!",
  "startStreak": "Comece sua sequência hoje!",
  
  // Rewards
  "rewards": "Recompensas",
  "rewardsCatalog": "Catálogo de recompensas",
  "rewardHistory": "Histórico de recompensas",
  "rechargeCard": "Cartão de recarga",
  "giftCard": "Vale-presente",
  "request": "Solicitar",
  "requestReward": "Solicitar recompensa",
  "notEnoughPoints": "Pontos insuficientes",
  "rewardRequested": "Recompensa solicitada com sucesso",
  "errorRequestingReward": "Erro ao solicitar recompensa",
  "reward": "Recompensa",
  "status": "Status",
  "pending": "Pendente",
  "approved": "Aprovado",
  "rejected": "Rejeitado",
  "requestDate": "Data da solicitação",
  "noRewardRequests": "Nenhuma solicitação de recompensa",
  "yourPoints": "Pontos",
  "noRewards": "De momento, não há recompensa disponível",
  "pendingRequest": "Pedido em curso",
  "alreadyRequestedReward": "Você já tem uma solicitação pendente para esta recompensa",
  "pleaseLogin": "Por favor, faça login para solicitar recompensas",

  // Partner Offers
  "partnerOffers": "Ofertas de Parceiros",
  "noPartnerOffers": "Nenhuma oferta de parceiros disponível",
  "claimOffer": "Ver",
  "requesting": "Solicitando...",
  "errorFetchingPartnerOffers": "Erro ao buscar ofertas de parceiros",
  "currentImage": "Imagem atual",
  
  // Surveys
  "surveys": "Pesquisas",
  "availableSurveys": "Pesquisas disponíveis",
  "startSurvey": "Iniciar pesquisa",
  "noSurveysAvailable": "Nenhuma pesquisa disponível",
  "surveyCompleted": "Pesquisa concluída! Você ganhou {{points}} pontos",
  "completeSurvey": "Concluir pesquisa",
  "nextQuestion": "Próxima pergunta",
  "question": "Pergunta",
  "pointsWorth": "Vale",
  "completedSurveys": "Pesquisas concluídas",
  "noCompletedSurveys": "Nenhuma pesquisa concluída",
  "completedDate": "Data de conclusão",
  "yes": "Sim",
  "no": "Não",
  
  // Settings
  "settings": "Configurações",
  "profileSettings": "Configurações do perfil",
  "changePassword": "Alterar senha",
  "updateProfile": "Atualizar perfil",
  "updatePassword": "Atualizar senha",
  "profileUpdated": "Perfil atualizado com sucesso",
  "passwordUpdated": "Senha atualizada com sucesso",
  "deleteAccount": "Excluir conta",
  "deleteMyAccount": "Excluir minha conta",
  "deleteAccountDescription": "Se você deseja excluir sua conta e todos os dados associados, clique no botão abaixo. Esta ação o redirecionará para um formulário onde você poderá enviar sua solicitação de exclusão.",
  
  // Navigation
  "dashboard": "Painel",
  "notifications": "Notificações",
  "noNotifications": "Nenhuma notificação",
  "markAllAsRead": "Marcar todas como lidas",
  "markAsRead": "Marcar como lida",
  
  // Footer
  "privacyPolicy": "Política de Privacidade",
  "termsOfService": "Termos de Serviço",
  "legalNotice": "Aviso Legal",
  "contact": "Contato",
  "contactEmail": "contact@qonso.app",
  "allRightsReserved": "© 2025 Qonso. Todos os direitos reservados."
};